import React, { Fragment, useState } from 'react';
import {
  Card, Button, UncontrolledDropdown,
  DropdownMenu, DropdownItem, DropdownToggle
} from 'reactstrap';
import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import { putAPI_Update_Vouchers, gAPI_Vouchers_By_Id, gAPI_Internal_Property_By_Id } from '../../../../../../constants/APIs';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import ReviewVoucher from './forms/ReviewVoucher';
import VoucherConnection from './forms/VoucherConnection';
import VouchersForm from './forms/VouchersForm';

const VoucherListItem = ({ item, isBuyOption, LoadData, voucherList, handleVoucherPaymentsByIdforthirdParty, locale
  , invitation, propertyId, handleReject, handleApproval, inviteVoucher, extractData, ShowInviteVoucher, currency, handleBuyOptionSetings, handleVoucherFilter, handleVoucherPaymentsById }) => {
  const [id, setId] = useState(item.id);

  const [isUpdating, setIsUpdating] = useState(false);
  const [isBuyOptionForm, setisBuyOptionForm] = useState(false);
  const [currentInvitation, setCurrentInvitation] = useState();
  const [propertyData, setPropertyData] = useState({
    bmbVoucherProcessingFee: 0
  });
  const [showReviewVoucher, setShowReviewVoucher] = useState(false);
  const [showConnectedVoucher, setShowConnectedVoucher] = useState({
    'groups': [],
    'property': [],
    'id': [],
    'senderGroupId': '',
    'senderPropertyId': '',
    'isShow': false,
    'invitationtype': ''
  });
  const [voucherData, setVoucherData] = useState({
    'connectionId': '',
    'invitationId': '',
    'processingFee': '',
    'approvalStatus': '',
    'groupId': item.groupId
  });
  let [voucher, setVoucher] = useState();
  const [isShow, setIsShow] = useState(false);
  const handleViewDetails = (id, connection, status) => {
    let data = invitation !== undefined && invitation.filter((f) => f.invitationId === id);
    if (data.length > 0) {
      setVoucherData({ connectionId: connection, groupId: item.groupId, approvalStatus: status, invitationId: data[0].invitationId, processingFee: data[0].processingFee });
    }
  };
  const close_clicked = () => {
    setShowReviewVoucher(!showReviewVoucher);
  }
  const handleConnectedVoucher = (id) => {
    let temp = invitation.filter((f) => f.invitationId === id);
    if (temp.length > 0) {
      if (temp[0].groups.length === 1 && temp[0].propertys.length === 1) {
        handleReject(item.id, item.invitationId, 'Approve', item.processingFee);
        handleShow();
        return;
      }
      setShowConnectedVoucher({
        groups: temp[0].groups, property: temp[0].propertys, id: temp[0].id, isShow: true,
        senderGroupId: temp[0].senderGroup,
        senderPropertyId: temp[0].senderProperty, invitationtype: temp[0].type
      });
      setCurrentInvitation(temp[0]);
    }
  };
  const handlePreview = () => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Vouchers_By_Id}/${id}`,
    }).then((res) => {
      if (res.data.taxIncluded === true) {
        let val = parseFloat(res.data.price) -
          parseFloat(res.data.taxIncluded === true ? res.data.taxAmount : 0);
        res.data.taxPercentage = ((parseFloat(res.data.taxAmount) * 100) / (
          val)
        ).toFixed(2);
      } else {
        res.data.taxPercentage = ((parseFloat(res.data.taxAmount) * 100) / (
          parseFloat(res.data.price) -
          parseFloat(res.data.taxIncluded === true ? res.data.taxAmount : 0))
        ).toFixed(2);
      }
      res.data.taxIncluded = res.data.taxIncluded.toString();
      setVoucher(res.data);
      setShowReviewVoucher(!showReviewVoucher)
      if (res.data.propertyId === propertyId) {
        loadProperty(res.data.propertyId, voucherData.groupId === undefined ? getGroupID() : voucherData.groupId);
      } else {
        loadProperty(res.data.propertyId, voucherData.groupId === undefined ? getGroupID() : voucherData.groupId);
      }
    });
  };
  const loadProperty = (propertyId, group_id) => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_Internal_Property_By_Id}/${propertyId}?group_id=${group_id}`,
    })
      .then((res) => {
        setPropertyData(res.data);
      })
  };
  const handleUpdate = (type) => {
    if (type === 'Approve') {
      handleConnectedVoucher(item.invitationId);
    }
    else {
      handleReject(item.id, voucherData.invitationId, 'Reject', item.processingFee);
      handleShow();
    }
  };

  const handleShow = () => {
    setIsShow(false);
  }
  const handleSubmit = (data) => {
    const formmatedData = { ...data, updater: 'admin' };
    AxiosAPI({
      method: 'put',
      url: `${putAPI_Update_Vouchers}/${id}`,
      data: formmatedData,
    }).then(() => {
      extractData();
      if (isBuyOption) {
        setisBuyOptionForm(!isBuyOptionForm);
      } else {
        setIsUpdating(!isUpdating);
      }
    });
  };
  console.log(showReviewVoucher);
  return (
    <Fragment>
      {item.thirdPartyVoucher && item.approvalStatus === '3' ? null :
        <Colxx xxs="12">
          <Card className="d-flex flex-row mb-3">
            <div className="react-photo-gallery--gallery">
              <div style={{ display: 'flex', flexFlow: 'row wrap' }}>
                <div style={{
                  margin: '2px', 'position': 'relative'
                }}>
                  <img
                    alt="Thumbnail"
                    src={
                      item.images[0]
                        ? item.images[0].url
                        : 'https://via.placeholder.com/250x150'
                    }
                    className="ml-2 my-3 list-thumbnail responsive border-0"
                  />
                  {item.thirdPartyVoucher ? <span className="badge badge-pill badge-primary
            position-absolute badge badge-top-voucher">
                    {item.propertyName}</span> : null}
                </div>
              </div>
            </div>

            <div className="pl-2 d-flex flex-grow-1 min-width-zero">
              <div className="card-body align-self-center d-flex flex-column flex-lg-row justify-content-between min-width-zero align-items-lg-center">
                {/* {item.thirdPartyVoucher && item.approvalStatus === '1' && (
                  <Fragment>
                    <button type="button" className="btn btn-link" onClick={() => {
                      handleApproval(item.connectionId, item.invitationId);
                    }}>Approve </button>
                    <button type="button" className="btn btn-link" onClick={() => {
                      handleReject(item.connectionId, item.invitationId);
                    }}>Reject </button>
                  </Fragment>
                )} */}
                <p className="mb-1 text-center text-muted text-small w-25 w-sm-100">
                  <b>{item.name}</b>

                </p>
                <p className="mb-1 text-center text-muted text-small w-20 w-sm-100">
                  {item.thirdPartyVoucher && item.approvalStatus === '1' ?
                    <b style={{ color: 'red' }}>Waiting for approval</b>
                    : <b>{item.status}</b>}
                </p>
                <p className="mb-1 text-center text-muted text-small w-20 w-sm-100">
                  {currency} {item.price}
                </p>
                <p className="mb-1 text-center text-muted text-small w-20 w-sm-100">
                  {item.discount}%
                </p>
                <p className="mb-1 text-center text-muted text-small w-15 w-sm-100">
                  <button type="button" className="btn btn-link" onClick={() => {
                    if (!item.thirdPartyVoucher) {
                      handleVoucherPaymentsById(item.id, false);
                      handleVoucherFilter('Active');
                    } else {
                      handleVoucherPaymentsByIdforthirdParty(item.id, false, item.groupId, item.propertyId);
                      handleVoucherFilter('Active');
                    }
                  }}>Purchased : {item.totalSell} </button>
                </p>
                <p className="mb-1 text-center text-muted text-small w-20 w-sm-100">
                  <button type="button" className="btn btn-link" onClick={() => {
                    if (!item.thirdPartyVoucher) {
                      handleVoucherPaymentsById(item.id, true);
                      handleVoucherFilter('Redeem');
                    } else {
                      handleVoucherPaymentsByIdforthirdParty(item.id, true, item.groupId, item.propertyId);
                      handleVoucherFilter('Redeem');
                    }
                  }}>Redeemed : {item.totalRedeem} </button>
                </p>
                <p className="mb-1 text-center text-muted text-small w-20 w-sm-100">
                  {currency}
                  {item.discountedPrice}
                </p>

                {/* {!item.thirdPartyVoucher ? (<div className="w-15 text-center w-sm-100">
                  <UpdateVouchersForm
                    id={item.id}
                    propertyId={propertyId}
                    isBuyOption={isBuyOption}
                    LoadData={LoadData}
                  /> </div>) : <div className="w-15 text-center w-sm-100"></div>} */}
                {!item.thirdPartyVoucher && item.approvalStatus !== 1 ?
                  < UncontrolledDropdown className="w-15 text-center w-sm-100">
                    <DropdownToggle caret color="outline-dark" size="xs">
                      more
                    </DropdownToggle>
                    <DropdownMenu>
                      {!item.thirdPartyVoucher && <DropdownItem
                        key='Accept'
                        onClick={() => {
                          setId(item.id);
                          setIsUpdating(!isUpdating);
                        }}
                      >Edit
                      </DropdownItem>}
                      {item.options && !item.thirdPartyVoucher && <DropdownItem
                        key='Option'
                        onClick={() => {
                          handleBuyOptionSetings(true, item.id);
                        }}
                      >  Buy Option
                      </DropdownItem>}
                      <DropdownItem>
                        <p onClick={() => handlePreview()}>
                          Preview
                        </p>
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown> :
                  <UncontrolledDropdown className="w-15 text-center w-sm-100" >
                    <DropdownToggle caret color="outline-dark" size="xs">
                      more
                    </DropdownToggle>
                    <DropdownMenu>
                      {item.thirdPartyVoucher && item.approvalStatus === '1' ? (<Fragment>
                        <DropdownItem
                          key='Accept'
                          onClick={() => {
                            // if (item.invitationtype === 'Sell')
                            //   handleApproval(item.id, item.invitationId);
                            // else {
                            handleConnectedVoucher(item.invitationId);
                          }}
                        >Accept
                        </DropdownItem>
                        <DropdownItem
                          key='Reject'
                          onClick={() => {
                            handleReject(item.id, item.invitationId, 'Reject', item.processingFee);
                          }}
                        >
                          Reject
                        </DropdownItem>
                      </Fragment>) : <Fragment>

                      </Fragment>}
                      {item.thirdPartyVoucher && item.approvalStatus === '2' &&
                        < DropdownItem
                          key='Selling'
                          onClick={() => {
                            handleReject(item.id, item.invitationId, 'StopSelling', item.processingFee);
                          }}
                        >
                          Stop Selling
                        </DropdownItem>
                      }
                      {item.thirdPartyVoucher && item.approvalStatus === '4' &&
                        < DropdownItem
                          key='Reject'
                          onClick={() => {
                            handleReject(item.id, item.invitationId, 'Approve', item.processingFee);
                          }}
                        >
                          Start Selling
                        </DropdownItem>
                      }
                      <DropdownItem
                        key='View'
                        onClick={() => { handleViewDetails(item.invitationId, item.connectionId, item.approvalStatus); setId(item.id); setIsShow(!isShow); }}
                      >
                        View details
                      </DropdownItem>
                      <DropdownItem>
                        <p onClick={() => handlePreview()}>
                          Preview
                        </p>
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                }
              </div>
            </div>
          </Card >
          {showReviewVoucher && <ReviewVoucher close_clicked={close_clicked} locale={locale} isCheckoutView={false} propertyData={propertyData} isVoucherEngine={true} data={voucher}></ReviewVoucher>}
        </Colxx >
      }
      {
        isShow && <VouchersForm
          formLabel="Update the Voucher"
          visible={isShow}
          toggle={() => {
            setIsShow(!isShow);
          }}
          id={id}
          handleUpdate={handleUpdate}
          approvalStatus={voucherData.approvalStatus}
          invitationId={item.invitationId}
          processingFee={voucherData.processingFee}
          propertyId={propertyId}
          handleReject={handleReject}
          thirdPartyVoucher={item.thirdPartyVoucher}
          groupId={voucherData.groupId}
        />
      }
      <div>
        {isUpdating && (
          <VouchersForm
            formLabel="Update the Voucher"
            visible={isUpdating}
            toggle={() => {
              setIsUpdating(!isUpdating);
            }}
            id={id}
            submit={handleSubmit}
            inviteVoucher={inviteVoucher}
            approvalStatus={voucherData.approvalStatus}
            invitationId={item.invitationId}

            thirdPartyVoucher={item.thirdPartyVoucher}
            handleReject={handleReject}
            ShowInviteVoucher={ShowInviteVoucher}
            propertyId={propertyId}
            groupId={voucherData.groupId}
          />
        )}
      </div>
      {
        showConnectedVoucher.isShow && <VoucherConnection propertyId={propertyId}
          voucherList={voucherList} id={showConnectedVoucher.id}
          LoadData={LoadData} groups={showConnectedVoucher.groups}
          invitationId={showConnectedVoucher.id}
          senderGroupId={showConnectedVoucher.senderGroupId}
          senderPropertyId={showConnectedVoucher.senderPropertyId}
          invitation={currentInvitation}
          handleShow={handleShow}
          extractData={extractData}
          visible={showConnectedVoucher.isShow}
          handleApproval={handleApproval}
          voucherId={id}
          property={showConnectedVoucher.property}
          invitationtype={showConnectedVoucher.invitationtype}
          toggle={() => setShowConnectedVoucher({ ...showConnectedVoucher, isShow: false })}
        ></VoucherConnection>
      }

    </Fragment >
  );
}

export default React.memo(VoucherListItem);





